import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';

import {
 // Box,
 // Button,
 // ListItemIcon,
  MenuItem,
 // Typography,
 // TextField,
} from '@mui/material';
// import { useDropzone } from "react-dropzone";
// import Cropper from "react-easy-crop";
// import Slider from "@mui/material/Slider";
// import Button from "@mui/material/Button";
// import Alert from "@mui/material/Alert";
// import DropzoneComponent from "./DropzoneComponent"; // Import the custom Dropzone
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogTitle from "@mui/material/DialogTitle";
import {MaterialReactTable} from 'material-react-table';
const QualityReportsEdit = () => {
  let { id } = useParams();
  const [permission, setPermission] = useState({});

  const [ordersLists, setOrdersLists] = useState([]);
  const [palletlist, setPlletlist] = useState([]);
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [value, setValue] = useState({});

  // // IMAGE HANDLING STATES
  // const [images, setImages] = useState([]);
  // const [showCropper, setShowCropper] = useState(false);


  useEffect(() => {
        setPermission(FindModuleById(447)); 
console.log(permission);



    axios.get(`/quality-report/edit2/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.report);
          setOrdersLists([
            { value: response.data.data.report.order, label: response.data.data.report.order_detail.po_number }
      
          ]);
         const fetchedPallets = response.data.data.report.pallets;
         setPlletlist(fetchedPallets);  
         axios.get(`/orders-quality-report/listing-shipped-delivered-current/${response.data.data.report.order}`,  {
           headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
         })
         .then((responses) => {
           if (responses.data.code === 200) {
            let orders = responses.data.data.orders;

            let orderlisting = orders.map((ord, index) => ({
              label: ord.po_number,
              value: ord.id,
              key: `order-${index}`,
            }));
            setOrdersLists(orderlisting);
          }
          })
        }
      }).catch((error) => {
        console.log(error);
      });
  }, [id]);




  const formik = useFormik({
    initialValues: {
      id: id,
      order: value.order,
      sender: value.sender,
      customer: value.customer,
      transport: value.transport,
      transport_number: value.transport_number,
      product: value.product,
      ref: value.ref,
      date: value.date,
    
     // pallets: palletlist,
  
    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
    //  console.log("Form submitted with values: ", values); // Check if form submission triggers

      axios
        .post("/quality-report/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("update Report");
          if (response.data.code === 200) {
            setSubmitting(false);
            toast.success(response.data.message);
            //setBackendSuccess(response.data.message);
            setTimeout(() => {
              window.location.href = "/quality-reports";
            }, 500);
          } else {
            setBackendErrors(response.data.error);
            setSubmitting(false);
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    },
  });
  const getQualityReportData = (event) => {

    const order_id = event.value;
    if(order_id !=''){
      axios
      .get(`/orders/get-quality-reports/${order_id}`,  {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let quality_data = response.data.data.quality;
      //    console.log(quality_data);

            // Use setFieldValue to update the customer and other fields
                formik.setFieldValue('customer', quality_data.customer);
                formik.setFieldValue('transport', quality_data.transport);
                formik.setFieldValue('transport_number', quality_data.transport_number);
                formik.setFieldValue('product', quality_data.product);
                formik.setFieldValue('ref', quality_data.ref);
                formik.setFieldValue('date', quality_data.date);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  

  }
  // const toggleMobileMenu = () => {
  //   setMenu(!menu);
  // };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];

  };



  const ImageCell = ({ row }) => {
    const images1 = row.original?.images || []; 
    const images2 = row.original?.extra_images || [];
  
    const flatImages = [...images1, ...images2].flatMap(imageGroup => {
      return Array.isArray(imageGroup) ? imageGroup : Object.values(imageGroup);
    });
  
    const [popupImage, setPopupImage] = React.useState(null);
  
    return (
      <div>
        {/* Display images */}
        <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
          {flatImages.length > 0 ? (
            flatImages.map((imgObj, index) => (
              <img
                key={index}
                src={imgObj.image} 
                alt={`Image ${index + 1}`}
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'cover',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  cursor: 'pointer',
                }}
                onClick={() => setPopupImage(imgObj.image)}
              />
            ))
          ) : (
            <span>No Images</span>
          )}
        </div>
  
        {/* Popup */}
        {popupImage && (
          <div
            style={{
              position: 'fixed',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
            }}
            onClick={() => setPopupImage(null)}
          >
            <img
              src={popupImage}
              alt="Popup"
              style={{
                maxWidth: '90%',
                maxHeight: '90%',
                borderRadius: '10px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)',
              }}
            />
          </div>
        )}
      </div>
    );
  };
  
  // ✅ Add PropTypes validation
  ImageCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        images: PropTypes.arrayOf(
          PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.object), // If images is an array of objects
            PropTypes.object, // If images is an object
          ])
        ),
        extra_images: PropTypes.arrayOf(
          PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.object),
            PropTypes.object,
          ])
        ),
      }),
    }).isRequired, // Ensures `row` is required
  };

  const columns =
  [
   

  

     
    {
      //accessorKey: 'product', //normal accessorKey
      header: 'Pallet Number',
      accessorFn: (row) => `Pallet ${row.pallet_number}`,
    },  
    {
      accessorKey: 'product', //normal accessorKey
      header: 'Product/Variety',
    }, 
    {
      accessorKey: 'temperature', //normal accessorKey
      header: 'Temperature ',
    },
    {
      accessorKey: 'size', //normal accessorKey
      header: 'Size',
    },
    {
      accessorKey: 'sample_weight', //normal accessorKey
      header: 'Sample weight',
    },
  
    {
      accessorKey: 'class', //normal accessorKey
      header: 'Class',
    },
  
    {
      accessorKey: 'box_net_weight', //normal accessorKey
      header: 'Box net weight',
    },
    {
      accessorKey: 'packaging', //normal accessorKey
      header: 'Packaging',
    },
    {
      accessorKey: 'lot_number', //normal accessorKey
      header: 'Lot number',
    },
    {
      accessorKey: 'number_of_boxes', //normal accessorKey
      header: 'Number of boxes',
    },
    {
      accessorKey: 'palletesation', //normal accessorKey
      header: 'Palletesation',
    },
    {
      accessorKey: 'country', //normal accessorKey
      header: 'Country of origin',
    },
    {
      accessorKey: 'label_conformity', //normal accessorKey
      header: 'Label conformity',
    },

    // {
    //   header: 'Images',
    //   Cell: ({ row }) => {
    //     const imagess = row.original.images; // Access the images array
    
    //     const flatImages = imagess.flatMap(imageGroup => {
    //       return Array.isArray(imageGroup) ? imageGroup : Object.values(imageGroup);
    //     });
    
    //     // State to manage popup visibility and selected image
    //     const [popupImage, setPopupImage] = React.useState(null);
    
    //     return (
    //       <div>
    //         {/* Display images */}
    //         <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
    //           {flatImages && flatImages.length > 0 ? (
    //             flatImages.map((imgObj, index) => (
    //               <img
    //                 key={index}
    //                 src={imgObj.image} // Access the image URL
    //                 alt={`Image ${index + 1}`}
    //                 style={{
    //                   width: '50px',
    //                   height: '50px',
    //                   objectFit: 'cover',
    //                   borderRadius: '4px',
    //                   border: '1px solid #ddd',
    //                   cursor: 'pointer', // Indicate clickable image
    //                 }}
    //                 onClick={() => setPopupImage(imgObj.image)} // Set the clicked image
    //               />
    //             ))
    //           ) : (
    //             <span>No Images</span>
    //           )}
    //         </div>
    
    //         {/* Popup */}
    //         {popupImage && (
    //           <div
    //             style={{
    //               position: 'fixed',
    //               top: '0',
    //               left: '0',
    //               width: '100%',
    //               height: '100%',
    //               backgroundColor: 'rgba(0, 0, 0, 0.8)',
    //               display: 'flex',
    //               justifyContent: 'center',
    //               alignItems: 'center',
    //               zIndex: 1000,
    //             }}
    //             onClick={() => setPopupImage(null)} // Close popup on background click
    //           >
    //             <img
    //               src={popupImage}
    //               alt="Popup"
    //               style={{
    //                 maxWidth: '90%',
    //                 maxHeight: '90%',
    //                 borderRadius: '10px',
    //                 boxShadow: '0 4px 10px rgba(0, 0, 0, 0.5)',
    //               }}
    //             />
    //           </div>
    //         )}
    //       </div>
    //     );
    //   },
    // }
    {
      header: 'Images',
      Cell: ImageCell, // Use the ImageCell component
    }
  
     

   ];

   const editItem = (item)=>{
    console.log(item);
    window.location.href = "/quality-reports-editpallet/"+item.id;
  }
  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/quality-report/pallet/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                axios.get(`/quality-report/edit2/${id}`, {
                  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                }).then((response) => {
                  if (response.data.code === 200) {
                    setValue(response.data.data.report);
                   
                   const fetchedPallets = response.data.data.report.pallets;
                   setPlletlist(fetchedPallets);  
                   axios.get(`/orders-quality-report/listing-shipped-delivered-current/${response.data.data.report.order}`,  {
                     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                   })
                   .then((responses) => {
                     if (responses.data.code === 200) {
                      let orders = responses.data.data.orders;
          
                      let orderlisting = orders.map((ord, index) => ({
                        label: ord.po_number,
                        value: ord.id,
                        key: `order-${index}`,
                      }));
                      setOrdersLists(orderlisting);
                    }
                    })
                  }
                }).catch((error) => {
                  console.log(error);
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }
  
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => setMenu(!menu)} />
      <Sidebar />  <ToastContainer />
      <div className="page-wrapper">
      {permission && permission.update === 1 && (
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Edit Quality Report</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/quality-reports">Quality Report</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit  Quality Report</li>
                </ul>
              </div>
            </div>
          </div>
          
          <FormikProvider value={formik}>
            <form action="#" onSubmit={formik.handleSubmit}>
              {/* Additional fields and pallets */}
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group status">
                    <label>Order PO Number</label>
                    
                      <Select
                 

                     className="w-100"
                     value={ordersLists.find(option => option.value == formik.values.order) || null} // Ensure correct format
                     name="order"
                     onChange={(selectedOption) => {
                       handleSelectChange("order", selectedOption);
                       getQualityReportData(selectedOption);
                     }}
                     onBlur={formik.handleBlur}
                     options={ordersLists}
                     placeholder="Select"


                     
                    />
                   
                    <small>
                      {backendErrors.order && (
                        <span order="form-error mt-1">
                          {backendErrors.order}
                        </span>
                      )}
                    </small>
                  </div>
                
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>Sender </label>
                    <input
                      type="text"
                      name="sender"
                      value={formik.values.sender}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.sender && (
                        <span className="form-error mt-1">
                          {backendErrors.sender}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Customer </label>
                    <input
                      type="text"
                      name="customer"
                      value={formik.values.customer}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.customer && (
                        <span className="form-error mt-1">
                          {backendErrors.customer}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Transport </label>
                    <input
                      type="text"
                      name="transport"
                      value={formik.values.transport}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.transport && (
                        <span className="form-error mt-1">
                          {backendErrors.transport}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Transport Number </label>
                    <input
                      type="text"
                      name="transport_number"
                      value={formik.values.transport_number}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.transport_number && (
                        <span className="form-error mt-1">
                          {backendErrors.transport_number}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Product </label>
                    <input
                      type="text"
                      name="product"
                      value={formik.values.product}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.product && (
                        <span className="form-error mt-1">
                          {backendErrors.product}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>REF </label>
                    <input
                      type="text"
                      name="ref"
                      value={formik.values.ref}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.ref && (
                        <span className="form-error mt-1">
                          {backendErrors.ref}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Date </label>
                    <input
                      type="date"
                      name="date"
                      value={formik.values.date}
                      className="form-input form-control input-error"
                      onChange={(e) => {
                        formik.handleChange(e);
                        customHandleInput(e);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      {backendErrors.date && (
                        <span className="form-error mt-1">
                          {backendErrors.date}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
              </div>

              <div className="text-end mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={formik.isSubmitting}
                >
                  Update Report
                </button>
              </div>
            </form>
          </FormikProvider>

          
          <section className="comp-section">
                <div className="row">

                <div className="col-md-12">
                <h3 className="card-title" >
                    <br />
                    Pallets Listing 
                    <br />
                  </h3>

                <div className="table-responsive">

                      <MaterialReactTable columns={columns} data={palletlist} 
                        enableColumnOrdering
                        enablePinning
                      //
                        enableRowActions

                        //renderColumnActionsMenuItems 
                       // enableRowActions
                        //renderColumnActionsMenuItems 
                        renderRowActionMenuItems={({ row }) => [

                          // <MenuItem key="edit" onClick={() => addPallets(row.original.id)}>
                          //   Add Pallets
                          // </MenuItem>,

                          <MenuItem key="edit" onClick={() => editItem(row.original)}>
                            Edit
                          </MenuItem>,
                        //   <MenuItem key="view" onClick={() => FichedePalletePDF(row.original.id)}>
                        //   Download <img  id={`loader-image1`} className="loader-image loader-hide" src={loader_image}/> 
                        // </MenuItem>,
                         
                        <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                            Delete
                          </MenuItem>,
                        ]}
                        initialState={{
                          pagination: { pageSize: 50 }, // Set default page size to 50
                        }}
                      
                      />
                      </div>
                   
                </div>
                </div>
            </section>
        </div>
)}

        
      </div>
    </div>
  );
};

export default QualityReportsEdit;
